const serviceName = '/service/user'
export default serviceName
